import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
// Task037: Checkbox, Tooltip. Task048: Table sale; entran Card, Row, Col, Pagination, Spin, Empty, Typography, Collapse
import { Input, Select, Tag, Modal, Form, Button, Flex, Checkbox, Tooltip, message, Card, Row, Col, Pagination, Spin, Empty, Typography, Collapse } from 'antd'

import Main from '../components/Main'
import {
  LEADS_GET,
  LEAD_UPDATE,
  LEAD_EMAIL_PREVIEW,   // Task037
  LEAD_EMAIL_SEND,
  CLONES_GET,
  requestToServer,
  getLocalData
} from '../lib/helper'

// Task036: leads de los formularios de pretii.lat (antes solo llegaban por correo)

const STATUSES = [
  { value: 'nuevo',      label: 'Nuevo',      color: 'blue' },
  { value: 'contactado', label: 'Contactado', color: 'gold' },
  { value: 'cliente',    label: 'Cliente',    color: 'green' },
  { value: 'descartado', label: 'Descartado', color: 'default' }
]

// los mismos `from` que usa contactanos.astro, para leerlos en castellano
const SOURCE_LABELS = {
  'white-label-demo-request': 'Demo Marca Blanca',
  'white-label-start':        'Iniciar Marca Blanca',
  'expert-request':           'Hablar con experto',
  'agency-request-proposal':  'Propuesta Plan Agencia',
  'agency-provider':          'Proveedor (agencia)',
  'agency-contact':           'Consulta Plan Agencia',
  'navigation':               'Contacto (menú)',
  'direct':                   'Contacto directo',
  // Task058: clic en un botón de WhatsApp (POST /api/lead/click)
  'whatsapp-lp-marca-blanca': 'WhatsApp · Landing MB',
  'whatsapp-contactanos':     'WhatsApp · Contáctanos'
}

// Task064: canal que calcula la API (leadChannel en helpers.js). Sin etiqueta: 'campana' y 'referencia' (ya se ven
// la UTM y el referrer debajo).
const CHANNEL_TAGS = {
  'google-ads':       { label: 'Google Ads',                   color: 'blue' },
  'google-ads-antes': { label: 'Google Ads (visita anterior)', color: 'geekblue' },
  'meta-ads':         { label: 'Meta',                         color: 'purple' },
  'meta-ads-antes':   { label: 'Meta (visita anterior)',       color: 'magenta' },
  'campana-antes':    { label: 'Campaña (visita anterior)',    color: 'cyan' },
  'buscador':         { label: 'Buscador',                     color: 'green' },
  'sin-datos':        { label: 'Sin datos de origen',          color: 'orange' },
  'directo':          { label: 'Directo' }
}

const PAGE_SIZE = 20

// Task048: formatos de fecha a nivel de módulo (antes vivían dentro de las columnas de la tabla)
const fmtDateTime = d => new Date(d).toLocaleString('es-PE', { dateStyle: 'short', timeStyle: 'short' })
const fmtDay = d => new Date(d).toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit' })

// Task048: una card por lead (reemplaza la tabla de 7 columnas, que no entraba en los 800px de Main y obligaba
// a bajar al final de la página para mover el scroll horizontal). Va fuera de la pantalla a propósito: si se
// definiera adentro se remontaría en cada render y el "Ver detalle" abierto se cerraría al cambiar cualquier estado.
const LeadCard = ({ lead: r, onEdit, onMail }) => {
  const s = STATUSES.find( x => x.value === r.status ) || STATUSES[0]
  // Task037: avance de la secuencia y botón del siguiente correo (oculto para agencia o 4 de 4)
  const isDue = r.nextStep && new Date(r.nextDueAt) <= new Date()

  return (
    <Card size='small' style={{ marginBottom: 10, overflowWrap: 'anywhere' }}>   {/* anywhere: emails y campañas largas no deben generar scroll horizontal */}

      <Flex justify='space-between' align='flex-start' gap='small' wrap='wrap'>
        <div>
          <strong>{r.name}</strong>{ r.business && <span> · {r.business}</span> }<br/>
          <span style={{ color: '#888' }}>{fmtDateTime(r.createdAt)}</span>
        </div>
        <Flex gap='small' align='center' wrap='wrap'>
          <Tag color={s.color} style={{ marginInlineEnd: 0 }}>{s.label}</Tag>
          { r.platformName && <span>{r.platformName}</span> }
          <Button size='small' onClick={() => onEdit(r)}>Editar</Button>
        </Flex>
      </Flex>

      {/* 2 columnas en escritorio, 1 en celular */}
      <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
        <Col xs={24} sm={12}>
          { r.email }<br/>
          { r.phone && <a href={'https://wa.me/' + r.phone.replace(/\D/g, '')} target='_blank' rel='noreferrer'>{r.phone}</a> }
          <div>
            { r.country || '—' }{ r.city && <span> · {r.city}</span> }
            { r.isDatacenter && <Tag color='red' style={{ marginInlineStart: 6 }}>centro de datos</Tag> }
          </div>
        </Col>
        <Col xs={24} sm={12}>
          { SOURCE_LABELS[r.source] || r.source || '—' }
          { ( r.utmSource || r.utmMedium ) && <div>{[r.utmSource, r.utmMedium].filter(Boolean).join(' / ')}</div> }
          { r.utmCampaign && <div>{r.utmCampaign}</div> }
          {/* Task064: una etiqueta por canal (antes solo gclid / fbclid de esta visita) */}
          { CHANNEL_TAGS[r.channel] && <Tag color={CHANNEL_TAGS[r.channel].color}>{CHANNEL_TAGS[r.channel].label}</Tag> }
          {/* Task064: primera visita, solo si fue otro día */}
          { r.firstTouch && r.firstTouch.at && fmtDay(r.firstTouch.at) !== fmtDay(r.createdAt) &&
            <div style={{ color: '#888' }}>Primera visita: {fmtDay(r.firstTouch.at)} · {
              [r.firstTouch.utm_source, r.firstTouch.utm_medium].filter(Boolean).join(' / ')
              || r.firstTouch.referrer || r.firstTouch.landingPage }</div> }
          { !r.utmSource && r.referrer && <div>{r.referrer}</div> }
          <Flex gap='small' align='center' wrap='wrap' style={{ marginTop: 4 }}>
            <span>Correos: {r.seqStep || 0} de 4{ r.seqLastSentAt && <span> · último {fmtDay(r.seqLastSentAt)}</span> }</span>
            { r.nextStep && r.email &&
              <Tooltip title={ isDue ? 'Ya toca' : 'Toca desde el ' + fmtDay(r.nextDueAt) }>
                <Button size='small' type={ isDue ? 'primary' : 'default' } onClick={() => onMail(r, r.nextStep)}>
                  Correo {r.nextStep}
                </Button>
              </Tooltip> }
          </Flex>
        </Col>
      </Row>

      {/* mensaje y notas a la vista (2 líneas, con "más"); lo técnico, plegado */}
      { r.message &&
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', margin: '8px 0 0' }}
          ellipsis={{ rows: 2, expandable: 'collapsible', symbol: expanded => expanded ? 'menos' : 'más' }}>
          <strong>Mensaje:</strong> {r.message}
        </Typography.Paragraph> }
      { r.notes &&
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', margin: '4px 0 0' }}
          ellipsis={{ rows: 2, expandable: 'collapsible', symbol: expanded => expanded ? 'menos' : 'más' }}>
          <strong>Notas:</strong> {r.notes}
        </Typography.Paragraph> }
      <Collapse ghost size='small' style={{ marginTop: 4 }} items={[{
        key: 'detail',
        label: 'Ver detalle',
        children: (
          <div>
            <div>Página: {r.formPage || '—'} · Entrada: {r.landingPage || '—'}</div>
            {/* Task064: cookies de anuncios tal como llegaron (tienen la fecha del clic) */}
            { ( r.gclAw || r.fbc ) && <div>Cookies de anuncios: {[r.gclAw, r.fbc].filter(Boolean).join(' · ')}</div> }
            <div>reCAPTCHA: {r.recaptchaScore ?? '—'} · IP: {r.ip || '—'}</div>
            { r.updatedByUser && <div>Última edición: {r.updatedByUser.email}</div> }
          </div>
        )
      }]} />

    </Card>
  )
}

export default () => {
  const history = useHistory()

  const [leads, setLeads] = useState([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState(undefined)
  const [country, setCountry] = useState(undefined)
  const [source, setSource] = useState(undefined)
  const [countryOptions, setCountryOptions] = useState([])
  const [sourceOptions, setSourceOptions] = useState([])
  const [cloneOptions, setCloneOptions] = useState([])
  const [editing, setEditing] = useState(null)   // lead abierto en el modal
  const [due, setDue] = useState(false)          // Task037: filtro "le toca correo"
  const [mailing, setMailing] = useState(null)   // Task037: { lead, step, subject, html, to } en la vista previa
  const [sending, setSending] = useState(false)
  const [form] = Form.useForm()

  // descarta respuestas viejas si el filtro cambió mientras viajaba la petición (como Logs.js)
  const lastRequest = useRef(0)

  const fetchLeads = (pageToLoad) => {
    const requestId = ++lastRequest.current
    setLoading(true)
    requestToServer({ page: pageToLoad, search, status, country, source, due }, LEADS_GET).then( r => {
      if ( requestId !== lastRequest.current ) { return }
      setLeads(r.leads)
      setTotal(r.total)
      setPage(r.currentPage)
      setCountryOptions(r.countries)
      setSourceOptions(r.sources)
    }).catch(()=>{}).finally(() => setLoading(false))
  }

  useEffect(() => {
    const localData = getLocalData()
    if ( !localData || !localData.token ) { history.push('/login'); return }
    // clones para asociar un lead que se volvió cliente
    requestToServer({}, CLONES_GET).then( r => {
      setCloneOptions( r.clones.map( c => c.platformName ).sort() )
    }).catch(()=>{})
  }, [])

  // cualquier cambio de filtro vuelve a la página 1
  useEffect(() => { fetchLeads(1) }, [search, status, country, source, due])

  const openEdit = (lead) => {
    setEditing(lead)
    form.setFieldsValue({ status: lead.status, platformName: lead.platformName || undefined, notes: lead.notes || '' })
  }

  const saveEdit = () => {
    form.validateFields().then( values => {
      requestToServer({ id: editing.id, ...values }, LEAD_UPDATE).then( () => {
        message.success('Lead actualizado')
        setEditing(null)
        fetchLeads(page)
      }).catch(()=>{})
    })
  }

  // Task037: vista previa del correo `step` antes de enviarlo
  const openMail = (lead, step) => {
    requestToServer({ id: lead.id, step }, LEAD_EMAIL_PREVIEW).then( r => {
      setMailing({ lead, step, ...r })
    }).catch(()=>{})
  }

  const sendMail = () => {
    setSending(true)
    requestToServer({ id: mailing.lead.id, step: mailing.step }, LEAD_EMAIL_SEND).then( () => {
      message.success('Correo ' + mailing.step + ' enviado a ' + mailing.to)
      setMailing(null)
      fetchLeads(page)
    }).catch(()=>{}).finally(() => setSending(false))
  }

  return (
    <Main pageHeader={{ title: 'Leads', back: true }}>

      <Flex gap='small' wrap='wrap' style={{ marginBottom: '10px' }}>
        <Input.Search
          allowClear
          placeholder='Nombre, email, teléfono, negocio o clon'
          onSearch={ value => setSearch(value) }
          style={{ flex: '1 1 260px' }}
        />
        <Select allowClear placeholder='Estado' value={status} onChange={setStatus}
          options={STATUSES.map( s => ({ value: s.value, label: s.label }) )} style={{ width: 140 }} />
        <Select allowClear showSearch placeholder='País' value={country} onChange={setCountry}
          options={countryOptions.map( c => ({ value: c, label: c }) )} style={{ width: 100 }} />
        <Select allowClear placeholder='Origen' value={source} onChange={setSource}
          options={sourceOptions.map( s => ({ value: s, label: SOURCE_LABELS[s] || s }) )} style={{ width: 200 }} />
        <Checkbox checked={due} onChange={ e => setDue(e.target.checked) }>Le toca correo</Checkbox>   {/* Task037 */}
      </Flex>

      {/* Task048: cards en vez de la tabla */}
      <Spin spinning={loading}>
        { leads.map( l => <LeadCard key={l.id} lead={l} onEdit={openEdit} onMail={openMail} /> ) }
        { !loading && leads.length === 0 && <Empty description='Sin leads' /> }
      </Spin>

      <Flex justify='flex-end' style={{ margin: '10px 0' }}>
        <Pagination
          current={page}
          pageSize={PAGE_SIZE}
          total={total}
          showSizeChanger={false}
          onChange={ p => { fetchLeads(p); window.scrollTo(0, 0) } }   // al cambiar de página, volver arriba
        />
      </Flex>

      <Modal
        open={!!editing}
        title={editing ? editing.name || editing.email : ''}
        okText='Guardar'
        cancelText='Cancelar'
        onOk={saveEdit}
        onCancel={() => setEditing(null)}
      >
        <Form form={form} layout='vertical'>
          <Form.Item name='status' label='Estado' rules={[{ required: true }]}>
            <Select options={STATUSES.map( s => ({ value: s.value, label: s.label }) )} />
          </Form.Item>
          <Form.Item name='platformName' label='Clon (si se volvió cliente)'>
            <Select allowClear showSearch options={cloneOptions.map( c => ({ value: c, label: c }) )} />
          </Form.Item>
          <Form.Item name='notes' label='Notas'>
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Task037: vista previa y envío de un correo de la secuencia */}
      <Modal
        open={!!mailing}
        width={680}
        title={ mailing ? 'Correo ' + mailing.step + ' a ' + mailing.to : '' }
        okText='Enviar'
        cancelText='Cancelar'
        confirmLoading={sending}
        onOk={sendMail}
        onCancel={() => setMailing(null)}
      >
        { mailing && <>
          <Select
            value={mailing.step}
            onChange={ step => openMail(mailing.lead, step) }   // permite reenviar o adelantar otro paso (C3)
            options={[1, 2, 3, 4].map( s => ({ value: s, label: 'Correo ' + s }) )}
            style={{ width: 140, marginBottom: 10 }}
          />
          <div style={{ marginBottom: 10 }}><strong>Asunto:</strong> {mailing.subject}</div>
          {/* el HTML lo arma Pulpo con textos fijos y datos del lead escapados; el iframe sin scripts lo aísla del panel */}
          <iframe title='vista previa' srcDoc={mailing.html} sandbox='' style={{ width: '100%', height: 420, border: '1px solid #eee' }} />
        </> }
      </Modal>

    </Main>
  )
}
